document.documentElement.classList.remove('no-js')
document.documentElement.classList.add('js')

const header = document.querySelector('[data-site-header]')

if (header) {
  const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 16)
  updateHeader()
  window.addEventListener('scroll', updateHeader, { passive: true })
}

document.querySelectorAll('[data-announcement]').forEach((announcement) => {
  const key = `announcement-${announcement.dataset.announcement}`
  const close = announcement.querySelector('[data-announcement-close]')

  try {
    if (window.sessionStorage.getItem(key) === 'closed') announcement.hidden = true
  } catch (error) {
    announcement.hidden = false
  }

  close?.addEventListener('click', () => {
    announcement.hidden = true
    try {
      window.sessionStorage.setItem(key, 'closed')
    } catch (error) {
      announcement.hidden = true
    }
  })
})

document.querySelectorAll('[data-mobile-nav]').forEach((navigation) => {
  navigation.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      navigation.removeAttribute('open')
      navigation.querySelector('summary')?.focus()
    }
  })

  navigation.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => navigation.removeAttribute('open'))
  })
})

document.addEventListener('click', (event) => {
  document.querySelectorAll('[data-mobile-nav][open]').forEach((navigation) => {
    if (!navigation.contains(event.target)) navigation.removeAttribute('open')
  })
})

document.addEventListener('shopify:section:load', () => {
  document.documentElement.classList.add('js')
})
